import { useState } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import {
	MedicalProcedure,
	useLazyWorkplaceMedicalProceduresQuery,
} from '../../../graphql/graphql';
import useFlatPages from '../../Base/Hooks/useFlatPages';

interface MedicalProcedureWithImported extends MedicalProcedure {
	imported: boolean;
}

interface MedicalProceduresFilter {
	fulltext: string;
	fieldOfCare: string;
}

export default function useMedicalProcedures(getMedicalProceduresQuery: any) {
	const { page, setPage, getNextPage } = useFlatPages();
	const [data, setData] = useState<MedicalProcedureWithImported[]>([]);
	const [totalPages, setTotalPages] = useState(0);
	const [getWorkplaceMedicalProceduresQuery] =
		useLazyWorkplaceMedicalProceduresQuery();

	const { workplaceId } = useAppContext();

	const getMedicalProcedures = async (filter: MedicalProceduresFilter) => {
		const getMedicalProceduresResult = await getMedicalProceduresQuery({
			where: {
				...filter,
				version: 1,
			},
			pagination: {
				take: 40,
				skip: (page - 1) * 40,
			},
		});
		const medicalProcedures: MedicalProcedure[] =
			getMedicalProceduresResult.data?.medicalProcedures?.data || [];

		setTotalPages(
			getMedicalProceduresResult.data?.medicalProcedures?.meta?.totalPages,
		);

		const getWorkplaceMedicalProceduresResult =
			await getWorkplaceMedicalProceduresQuery({
				where: {
					workplaceId,
					medicalProcedureIds: medicalProcedures.map(procedure => procedure.id),
				},
				pagination: { take: 40 },
			});

		const workplaceMedicalProcedures =
			getWorkplaceMedicalProceduresResult.data?.workplaceMedicalProcedures
				?.data || [];
		const workplaceMedicalProceduresIds = workplaceMedicalProcedures.map(
			(procedure: any) => procedure.medicalProcedureId,
		);

		const dataWithImported = medicalProcedures.map(procedure => ({
			...procedure,
			imported: workplaceMedicalProceduresIds.includes(procedure.id),
		}));

		setData(dataWithImported);
		return dataWithImported;
	};

	return { getMedicalProcedures, getNextPage, page, setPage, data, totalPages };
}
